<div class="table-responsive">
  <table class="table">
    <thead>
    <tr>
      <th>Type</th>
      <th>Status</th>
      <th>Details</th>
      <th>Next rate</th>
      <th>No. of reports</th>
      <th>Profiles</th>
      <th>Options</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let subscription of (settingState | async).subscriptions">
      <td class="text-capitalize">{{subscription.subscription_interval}}ly</td>
      <td class="status-label text-capitalize">
        <span [ngClass]="subscription.status==='active' ? 'status-green' : 'status-red'">
          <span class="dot"></span>
          {{subscription.status}}
        </span>

      </td>
<!--      <td class="text-capitalize">{{subscription.provider}}</td>-->
      <td>
        <app-subscription-item-popup [subscriptionId]="subscription.id"></app-subscription-item-popup>
      </td>
<!--      <td>{{(subscription.start_date * 1000) | date:"short"}}</td>-->
<!--      <td>{{(subscription.current_period_start * 1000) | date:"short"}}</td>-->
      <td>{{(subscription.current_period_end * 1000) | date:"short"}}</td>
      <td>
        <span *ngIf="subscription.permissions['auditor.limit'] !== undefined">
          {{subscription.permissions['auditor.limit'].value}}
          <span *ngIf="subscription.user_permission !== undefined">
            (active {{subscription.user_permission.value}})
          </span>
        </span>

      </td>
      <td>
        <div *ngIf="subscription.profiles !== undefined && subscription.profiles.length > 0">
          <div *ngFor="let profile of subscription.profiles"><a class="link-underlined">
            &#64;{{profile.profile}}
          </a></div>
        </div>
        <span *ngIf="subscription.profiles === undefined || subscription.profiles.length === 0">No profiles</span>
      </td>
      <td>
        <a class="btn btn-red-outline" *ngIf="subscription.status === 'active'" (click)="onDeleteSubscription(subscription.id)">
          Cancel subscription
        </a>
        <span *ngIf="subscription.status !== 'active'">-</span>
      </td>
    </tr>
    </tbody>
  </table>
</div>
